import styles from "./ProductIframe.module.scss"

import React from "react"
import { useParams } from "react-router-dom"

import { WOWNET_CONTENT } from "@shared/constants"

export default function ProductIframe() {
  const { streamerName } = useParams<{ streamerName?: string }>()

  return (
    <div className={`iframeB ${styles.sidebarProductSize}`}>
      <iframe
        className={styles.sidebarProductSize}
        title="하단 와우넷"
        src={`${WOWNET_CONTENT.aside}?analid=${streamerName}`}
      />
    </div>
  )
}
